import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { socket } from "../../config/socket";
import { ApiLogin } from "../../api/auth/ApiAuth";
import { ReactComponent as LockIcon } from "../../icons/lock.svg";
import { ReactComponent as ArrobaIcon } from "../../icons/useredit.svg";
import logo from "../../assets/images/lg.png";
import logo2 from "../../assets/images/bg.png";
import {
  isMobile,
  isTablet,
  isDesktop,
  browserName,
  browserVersion,
  osName,
  osVersion,
  deviceType,
  engineName,
  engineVersion,
  getUA,
} from "react-device-detect";
import { Button } from "@mantine/core";
import { FaSignInAlt } from "react-icons/fa";
const Login = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    usuario: "",
    contrasena: "",
  });
  const [ipAddress, setIpAddress] = useState("");

  const navigate = useNavigate();
  const [deviceInfo, setDeviceInfo] = useState({});

  const initticket = () => {
    localStorage.setItem("init", 1);
    window.location.reload();
  };

  useEffect(() => {
    const info = {
      isMobile,
      isTablet,
      isDesktop,
      browserName,
      browserVersion,
      osName,
      osVersion,
      deviceType,
      engineName,
      engineVersion,
      getUA,
    };
    setDeviceInfo(info);
    console.log(info);
  }, []);

  useEffect(() => {
    socket.on("getIpSocket", (data) => {
      console.log(data);
      setIpAddress(data);
    });

    return () => {
      socket.off("getIpSocket", () => {});
    };
  }, []);

  useEffect(() => {
    document.getElementById("usuario").focus();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    socket.emit("ip", "");
    setLoading(true);
    const info = {
      ...deviceInfo,
      ipAddress,
    };
    const datax = {
      ...formData,
      info: info,
    };

    const resp = await ApiLogin(datax);
    const { sms, mensaje, data } = resp;
    if (sms === "ok") {
      localStorage.setItem("accessTokenAdm", data);
      window.location.href = "/";
    } else {
      toast.error(mensaje);
      setLoading(false);
    }
  };

  return (
    <div>
      <div
        className="w-100 h-100 d-flex justify-content-center align-items-center"
        style={{
          maxWidth: "768px",
          margin: "0 auto",
          padding: "20px 25px",
        }}
      >
        <div className=" w-100">
          <form className="form card-body " id="">
            <div className="w-100 text-centerv d-flex justify-content-center align-items-center flex-column">
              <div
                style={{ color: "#f6dfda", fontSize: "20px" }}
                onClick={() => initticket()}
                className="p-2 w-100 "
              >
                Init
              </div>
              <div
                style={{
                  height: "300px",
                  width: "300px",
                }}
                className=" mx-5  d-flex justify-content-center align-items-center"
              >
                <img src={logo} className="w-100" alt="" />
              </div>
            </div>
            <div className="form-group mb-2 bordecompleto bordesombreado">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex justify-content-center align-items-center inputIcon bordecompleto bordesombreado">
                  <ArrobaIcon />
                </div>
                <input
                  className="inputtext  w-80"
                  type="text"
                  placeholder="Digite su cedula"
                  name="usuario"
                  id="usuario"
                  value={formData.usuario}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="form-group bordecompleto bordesombreado">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex justify-content-center align-items-center inputIcon bordecompleto bordesombreado">
                  <LockIcon />
                </div>
                <input
                  className="inputtext "
                  type="password"
                  name="contrasena"
                  placeholder="Digite su contraseña"
                  value={formData.contrasena}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="mt-3">
              <Button
                onClick={handleSubmit}
                disabled={loading}
                className="w-100"
                leftIcon={<FaSignInAlt size={20} />}
                loading={loading}
                sx={{
                  backgroundColor: "#243c54",
                  color: "#fff",
                  borderColor: "#243c54",
                  borderRadius: "5px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: "#00416a",
                    borderColor: "#00416a",
                  },
                  "&:active": {
                    backgroundColor: "#00416a",
                    borderColor: "#00416a",
                  },
                  "&:focus": {
                    backgroundColor: "#00416a",
                    borderColor: "#00416a",
                  },
                  "&:disabled": {
                    backgroundColor: "#243c54",
                    borderColor: "#243c54",
                    cursor: "not-allowed",
                  },
                }}
              >
                INICIAR SGDINING
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
